import React from "react";
import CountryDropDown from "./CountryDropDown/CountryDropDown";
import DestinationDropDown from "./DestinationDropDown/DestinationDropDown";

function DropDown({children}){

    return(
      <>{children}</>
    )

}

DropDown.Country = CountryDropDown;
DropDown.Destination = DestinationDropDown;


export default DropDown;